import type { CSSProperties } from "react";

export const dashboardCardStyle: CSSProperties = {
  background: "var(--login-surface)",
  border: "1px solid var(--login-border)",
  borderRadius: "0.625rem",
  padding: "1rem",
  boxSizing: "border-box",
  minWidth: 0,
  overflow: "hidden",
};

export const dashboardTitleStyle: CSSProperties = {
  fontFamily: "'Barlow Condensed', sans-serif",
  fontSize: "0.95rem",
  fontWeight: 700,
  letterSpacing: "0.06em",
  lineHeight: 1.1,
  textTransform: "uppercase",
  color: "var(--login-muted)",
  margin: 0,
};

export const dashboardLabelStyle: CSSProperties = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "0.72rem",
  fontWeight: 800,
  letterSpacing: "0.04em",
  lineHeight: 1.15,
  color: "var(--login-muted)",
  textTransform: "uppercase",
};

export const dashboardMonoValueStyle: CSSProperties = {
  fontFamily: "'DM Mono', monospace",
  fontWeight: 400,
  lineHeight: 1.08,
  color: "var(--login-text)",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
  minWidth: 0,
};

export const dashboardMetricValueStyle: CSSProperties = {
  maxWidth: "100%",
  minWidth: 0,
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 700,
  lineHeight: 0.98,
  letterSpacing: "-0.018em",
  color: "var(--login-text)",
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
  overflowWrap: "normal",
  wordBreak: "normal",
};

export const dashboardComparisonStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  maxWidth: "100%",
  minWidth: 0,
  gap: "0.3rem",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "clamp(0.76rem, 1.4vw, 0.84rem)",
  fontWeight: 500,
  lineHeight: 1.2,
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
  overflowWrap: "normal",
  wordBreak: "normal",
};

export const dashboardComparisonColors = {
  positive: "var(--dashboard-semantic-positive)",
  negative: "var(--dashboard-semantic-negative)",
  neutral: "var(--dashboard-semantic-neutral)",
} as const;

export const dashboardRowDividerStyle: CSSProperties = {
  borderTop: "1px solid var(--login-border)",
};

export const dashboardScrollablePanelStyle: CSSProperties = {
  overflowY: "auto",
  overflowX: "hidden",
  overscrollBehavior: "contain",
  minWidth: 0,
};

export const dashboardScrollbarStyle = `
  .dashboard-subtle-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: color-mix(in srgb, var(--login-border) 70%, var(--login-muted)) transparent;
  }

  .dashboard-subtle-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .dashboard-subtle-scrollbar::-webkit-scrollbar-thumb {
    background: color-mix(in srgb, var(--login-border) 70%, var(--login-muted));
    border-radius: 999px;
  }
`;
